<template>
	<div class="login-wrapper login-page">
		<section class="login-showcase">
			<div class="login-showcase-orb login-showcase-orb-one"></div><div class="login-showcase-orb login-showcase-orb-two"></div>
			<div class="login-showcase-content">
				<div class="login-showcase-brand"><div class="homeLogo" role="img" aria-label="Logotipo Escalador"></div></div>
				<div class="login-showcase-copy"><h1>Gestão que acompanha<br>o seu negócio.</h1><p>Simples para operar. Completo para decidir.</p></div>
			</div>
			<small class="login-showcase-footer">Escalador ERP</small>
		</section>
		<section class="login-access">
			<div class="login-card">
				<div class="login-mobile-logo"><div class="homeLogo" role="img" aria-label="Logotipo Escalador"></div></div>
				<span class="login-access-kicker">Bem-vindo de volta</span><h2>Acesse sua conta</h2><p class="login-access-description">Informe seus dados para continuar no ambiente de gestão.</p>
				<form class="login-form" data-editing-ignore @submit.prevent="verificarLogin">
					<div><label for="loginUsuario">CPF/CNPJ ou e-mail</label><div class="login-input"><i class="far fa-user"></i><input id="loginUsuario" v-model="usuario" type="text" autocomplete="username" placeholder="Digite seu usuário" autofocus></div></div>
					<div><label for="loginSenha">Senha</label><div class="login-input"><i class="far fa-lock"></i><input id="loginSenha" v-model="senha" type="password" autocomplete="current-password" placeholder="Digite sua senha"></div></div>
					<div class="login-form-options"><div class="form-check form-switch"><input id="flexSwitchCheckChecked" v-model="manterConectado" class="form-check-input" type="checkbox"><label class="form-check-label" for="flexSwitchCheckChecked">Manter conectado</label></div><a href="javascript:;" data-bs-toggle="modal" data-bs-target="#modalEsqueciSenha">Esqueceu a senha?</a></div>
					<button type="submit" class="btn btn-primary login-submit"><span>Entrar no sistema</span><i class="far fa-arrow-right"></i></button>
				</form>
				<div class="login-security-note"><i class="far fa-lock-alt"></i><span>Seus dados são protegidos durante todo o acesso.</span></div>
			</div>
		</section>
      <!-- modalEsqueciSenha -->
      <div class="modal fade" id="modalEsqueciSenha" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
         <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
               <div class="modal-header bg-theme text-white">
                  <h5 class="modal-title">Recuperar Senha</h5>
                  <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" @click="resetModalRecuperacao"></button>
               </div>
               <div class="modal-body">
                  <!-- Passo 1: Email -->
                  <div v-if="passoRecuperacao === 1">
                     <p class="mb-3 text-dark">Digite seu email abaixo. Enviaremos um código de validação para você redefinir sua senha.</p>
                     <input type="email" class="form-control" placeholder="Seu email cadastrado" v-model="emailRecuperacao" @keyup.enter="enviarEmailRecuperacao">
                  </div>
                  
                  <!-- Passo 2: Código -->
                  <div v-if="passoRecuperacao === 2">
                     <p class="mb-3 text-dark">Enviamos um código para <strong>{{ emailRecuperacao }}</strong>. Digite-o abaixo.</p>
                     <input type="text" class="form-control text-center fs-4 letter-spacing-2" placeholder="Código de 6 dígitos" maxlength="6" v-model="codigoRecuperacao" @keyup.enter="validarCodigoRecuperacao">
                  </div>
                  
                  <!-- Passo 3: Nova Senha -->
                  <div v-if="passoRecuperacao === 3">
                     <p class="mb-3 text-dark">Código validado! Crie sua nova senha.</p>
                     <div class="mb-3">
                        <label class="form-label">Nova Senha</label>
                        <input type="password" class="form-control" placeholder="Nova senha (mín. 6 caracteres)" v-model="novaSenhaRecuperacao">
                     </div>
                     <div class="mb-3">
                        <label class="form-label">Confirmar Nova Senha</label>
                        <input type="password" class="form-control" placeholder="Confirme a nova senha" v-model="confirmarNovaSenhaRecuperacao" @keyup.enter="redefinirSenha">
                        <small v-if="avisoNovaSenha" class="text-danger d-block mt-1">{{ avisoNovaSenha }}</small>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-primary" v-if="passoRecuperacao === 1" @click="enviarEmailRecuperacao" :disabled="!emailRecuperacao">Enviar Código</button>
                  <button type="button" class="btn btn-primary" v-if="passoRecuperacao === 2" @click="validarCodigoRecuperacao" :disabled="codigoRecuperacao.length < 6">Validar Código</button>
                  <button type="button" class="btn btn-primary" data-editing-save v-if="passoRecuperacao === 3" @click="redefinirSenha" :disabled="!novaSenhaRecuperacao">Redefinir Senha</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="resetModalRecuperacao">Cancelar</button>
               </div>
            </div>
         </div>
      </div>
	</div>
</template>

<script>
import { mensagemErroApi } from '@/utils/mensagemErroApi'

export default {
	name: 'Login',
   data: function() {
		return {
			usuario: '',
         senha: '',
         manterConectado: false,
         email: '',
         cpf: '',
         password: '',
         emailRecuperacao: '',
         passoRecuperacao: 1,
         codigoRecuperacao: '',
         novaSenhaRecuperacao: '',
         confirmarNovaSenhaRecuperacao: ''
		}
	},
   computed: {
      // Aviso ao digitar (o botão não fica mais desabilitado sem explicação quando as senhas diferem)
      avisoNovaSenha() {
         if (!this.novaSenhaRecuperacao) return ''
         if (this.novaSenhaRecuperacao.length < 6) return 'A senha deve ter pelo menos 6 caracteres.'
         if (this.confirmarNovaSenhaRecuperacao && this.novaSenhaRecuperacao !== this.confirmarNovaSenhaRecuperacao) return 'As senhas não conferem.'
         return ''
      }
   },
   watch: {
      usuario: function(newValue) {
         this.detectarTipoUsuario(newValue);
      },
      senha: function(newValue) {
         this.password = newValue;
      }
   },
   mounted() {
      // Importa jQuery localmente para fechar o modal
      window.$ = window.$ || require('jquery');
      // Move o modal para o body para evitar problemas de z-index (tela escura)
      const modal = document.getElementById('modalEsqueciSenha');
      if (modal) {
         document.body.appendChild(modal);
      }
   },
   beforeDestroy() {
      const modal = document.getElementById('modalEsqueciSenha');
      if (modal && modal.parentNode === document.body) {
         document.body.removeChild(modal);
      }
   },
   methods: {
      detectarTipoUsuario: function(valor) {
         // Limpar variáveis anteriores
         this.email = '';
         this.cpf = '';
         
         if (!valor || valor.trim() === '') {
            return;
         }
         
         const valorLimpo = valor.trim();
         
         // Verificar se é email
         if (this.validarEmail(valorLimpo)) {
            this.email = valorLimpo;
         }
         // Verificar se é cpf (aceita com ou sem formatação)
         else if (this.validarCPF(valorLimpo)) {
            // Salvar sempre sem formatação para consistência
            this.cpf = valorLimpo.replace(/\D/g, '');
         }
         // Se não for email nem cpf, não definir nenhum tipo
      },
      
      validarEmail: function(email) {
         const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
         return regex.test(email);
      },
      
      validarCPF: function(cpf) {
         // Remove caracteres não numéricos
         const cpfLimpo = cpf.replace(/\D/g, '');
         
         // Verifica se tem 11 dígitos
         if (cpfLimpo.length !== 11) {
            return false;
         }
         
         // Verifica se não são todos os dígitos iguais
         if (/^(\d)\1{10}$/.test(cpfLimpo)) {
            return false;
         }
         
         // Validação do primeiro dígito verificador
         let soma = 0;
         for (let i = 0; i < 9; i++) {
            soma += parseInt(cpfLimpo.charAt(i)) * (10 - i);
         }
         let resto = (soma * 10) % 11;
         if (resto === 10 || resto === 11) resto = 0;
         if (resto !== parseInt(cpfLimpo.charAt(9))) {
            return false;
         }
         
         // Validação do segundo dígito verificador
         soma = 0;
         for (let i = 0; i < 10; i++) {
            soma += parseInt(cpfLimpo.charAt(i)) * (11 - i);
         }
         resto = (soma * 10) % 11;
         if (resto === 10 || resto === 11) resto = 0;
         if (resto !== parseInt(cpfLimpo.charAt(10))) {
            return false;
         }
         
         return true;
      },
      
		verificarLogin : function () {
         if (this.usuario.length > 0 && this.senha.length > 0) {
            const credenciais = {
               'email': this.email || null,
               'cpf': this.cpf || null,
               'password': this.password,
               'manterConectado': this.manterConectado
            };
            
            this.$store.dispatch('verificarCredenciais', credenciais);
         }
		},
      enviarEmailRecuperacao() {
         if (!this.validarEmail(this.emailRecuperacao)) {
            this.$toast.fire({ icon: 'warning', title: 'Digite um email válido!' });
            return;
         }
         
         this.$store.dispatch('alternarTelaCarregamento', 1);
         this.$axios({
            method: 'post',
            url: this.$store.state.urlRest + 'auth/forgot-password',
            data: { email: this.emailRecuperacao }
         }).then(() => {
            this.$toast.fire({ icon: 'success', title: 'Se o email existir, um código foi enviado!' });
            this.passoRecuperacao = 2;
         }).catch(() => {
            this.$toast.fire({ icon: 'error', title: 'Erro ao solicitar recuperação. Tente novamente.' });
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', -1);
         });
      },
      validarCodigoRecuperacao() {
         if (this.codigoRecuperacao.length < 6) return;
         this.$store.dispatch('alternarTelaCarregamento', 1);
         this.$axios({
            method: 'post',
            url: this.$store.state.urlRest + 'auth/verify-reset-code',
            data: { email: this.emailRecuperacao, code: this.codigoRecuperacao }
         }).then(() => {
            this.passoRecuperacao = 3;
         }).catch((error) => {
            let msg = error.response?.data?.message || error.response?.data || 'Código inválido';
            this.$toast.fire({ icon: 'error', title: 'Erro: ' + msg });
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', -1);
         });
      },
      redefinirSenha() {
         if (this.novaSenhaRecuperacao.length < 6) {
            this.$toast.fire({ icon: 'warning', title: 'A senha deve ter pelo menos 6 caracteres' });
            return;
         }
         if (this.novaSenhaRecuperacao !== this.confirmarNovaSenhaRecuperacao) {
            this.$toast.fire({ icon: 'warning', title: 'As senhas não conferem' });
            return;
         }
         this.$store.dispatch('alternarTelaCarregamento', 1);
         this.$axios({
            method: 'post',
            url: this.$store.state.urlRest + 'auth/reset-password',
            data: { 
               token: this.codigoRecuperacao, 
               newPassword: this.novaSenhaRecuperacao,
               confirmPassword: this.confirmarNovaSenhaRecuperacao 
            }
         }).then(() => {
            this.$editing.saved(this, document.getElementById('modalEsqueciSenha'));
            if (window.$) window.$('#modalEsqueciSenha').modal('hide');
            this.$toast.fire({ icon: 'success', title: 'Senha redefinida com sucesso! Faça login.' });
            this.resetModalRecuperacao();
         }).catch((error) => {
            this.$toast.fire({ icon: 'error', title: mensagemErroApi(error, 'Falha ao redefinir a senha.') });
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', -1);
         });
      },
      resetModalRecuperacao() {
         this.passoRecuperacao = 1;
         this.emailRecuperacao = '';
         this.codigoRecuperacao = '';
         this.novaSenhaRecuperacao = '';
         this.confirmarNovaSenhaRecuperacao = '';
      }
   }
}

</script>

<style scoped>
.login-page { background:#f4f7fb; display:grid; grid-template-columns:minmax(0,1fr) minmax(440px,1fr); min-height:100vh; overflow:hidden; }
.login-showcase { background:linear-gradient(145deg,#0b2d4d 0%,#0a5b6e 54%,#078f72 100%); color:#fff; min-height:100vh; overflow:hidden; padding:clamp(2rem,5vw,5rem); position:relative; }
.login-showcase::before { background-image:linear-gradient(rgba(255,255,255,.045) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.045) 1px,transparent 1px); background-size:42px 42px; content:""; inset:0; mask-image:linear-gradient(to bottom,rgba(0,0,0,.7),transparent); position:absolute; }
.login-showcase-content { display:flex; flex-direction:column; height:calc(100vh - clamp(4rem,10vw,10rem)); justify-content:center; max-width:690px; position:relative; z-index:2; }
.login-showcase-brand { align-items:center; display:flex; margin-bottom:clamp(3rem,8vh,6rem); }
.login-showcase-brand .homeLogo { background-size:calc(100% - 22px); filter:none; height:clamp(180px,22vw,250px); margin:0; width:clamp(180px,22vw,250px); }
.login-showcase-copy { max-width:620px; }
.login-showcase h1 { font-size:clamp(2.1rem,3.6vw,4rem); font-weight:850; letter-spacing:-.045em; line-height:1.04; margin:0 0 1rem; }
.login-showcase-copy p { color:rgba(255,255,255,.76); font-size:clamp(.95rem,1.15vw,1.1rem); line-height:1.5; margin:0; }
.login-showcase-footer { bottom:1.2rem; color:rgba(255,255,255,.55); left:clamp(2rem,5vw,5rem); position:absolute; z-index:2; }
.login-showcase-orb { border-radius:50%; filter:blur(4px); position:absolute; }.login-showcase-orb-one { background:rgba(56,189,248,.18); height:420px; right:-170px; top:-140px; width:420px; }.login-showcase-orb-two { background:rgba(52,211,153,.18); bottom:-200px; height:480px; left:-210px; width:480px; }
.login-access { align-items:center; background:#fff; display:flex; justify-content:center; min-height:100vh; padding:3rem clamp(2rem,7vw,7rem); }
.login-card { max-width:460px; width:100%; }.login-mobile-logo { display:none; }.login-access-kicker { color:var(--primary-color,#2563eb); display:block; font-size:12px; font-weight:800; letter-spacing:.1em; margin-bottom:.65rem; text-transform:uppercase; }.login-card h2 { color:#172033; font-size:2rem; font-weight:850; letter-spacing:-.025em; margin:0 0 .5rem; }.login-access-description { color:#6b778c; font-size:14px; margin-bottom:2rem; }
.login-form { display:flex; flex-direction:column; gap:1.15rem; }.login-form>div>label { color:#344054; display:block; font-size:12px; font-weight:750; margin-bottom:.45rem; }.login-input { align-items:center; background:#f8fafc; border:1px solid #d9e1eb; border-radius:9px; display:flex; height:50px; overflow:hidden; position:relative; transition:border-color .18s ease,box-shadow .18s ease,background .18s ease; }.login-input:focus-within { background:#fff; border-color:var(--primary-color,#2563eb); box-shadow:0 0 0 3px rgba(37,99,235,.1); }.login-input i { color:#7b8799; font-size:15px; left:1rem; margin:0; pointer-events:none; position:absolute; top:50%; transform:translateY(-50%); z-index:1; }.login-input input { background:transparent; border:0; box-sizing:border-box; color:#172033; flex:1 1 auto; font-size:14px; height:100%; min-width:0; outline:0; padding:0 1rem 0 3.15rem !important; width:100%; }.login-input input::placeholder { color:#a4adba; }
.login-form-options { align-items:center; display:flex; justify-content:space-between; }.login-form-options .form-check-label { color:#5f6c80; font-size:12px; }.login-form-options a { color:var(--primary-color,#2563eb); font-size:12px; font-weight:750; text-decoration:none; }.login-submit { align-items:center; border-radius:9px; display:flex; font-size:14px; font-weight:750; height:50px; justify-content:space-between; padding:0 1.15rem; }.login-security-note { align-items:center; border-top:1px solid #e8edf3; color:#8a95a5; display:flex; font-size:11px; gap:.55rem; justify-content:center; margin-top:2rem; padding-top:1.25rem; }
@media (max-width:991.98px) { .login-page { grid-template-columns:1fr; }.login-showcase { display:none; }.login-access { padding:2rem 1.25rem; }.login-mobile-logo { display:block; margin-bottom:2rem; }.login-mobile-logo .homeLogo { height:64px; margin:0; width:170px; }.login-card h2 { font-size:1.75rem; } }
@media (max-width:420px) { .login-form-options { align-items:flex-start; flex-direction:column; gap:.8rem; }.login-access { padding:1.5rem 1rem; } }
</style>
